import { Card, List, Tag, Typography, Empty } from 'antd'
import { CalendarOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

interface CalendarEvent {
  id: number
  titolo: string
  descrizione?: string
  data_inizio: string
  data_fine: string
  work_order_id?: number
}

const { Text } = Typography

export function CalendarMiniWidget() {
  const navigate = useNavigate()
  const today = new Date().toISOString().split('T')[0]

  const { data, isLoading } = useQuery<CalendarEvent[]>({
    queryKey: ['dashboard', 'calendar-today', today],
    queryFn: async () => {
      const res = await axiosInstance.get(`/calendar-events/?start_date=${today}&end_date=${today}&limit=20`)
      return res.data
    },
    staleTime: 60000,
  })

  const events = data ?? []

  return (
    <Card
      size="small"
      title={<><CalendarOutlined style={{ marginRight: 6 }} />Agenda di oggi</>}
      extra={
        <Tag>
          {new Date().toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}
        </Tag>
      }
      style={{ cursor: 'pointer' }}
      onClick={() => navigate('/calendar')}
    >
      {!isLoading && events.length === 0 ? (
        <Empty description="Nessun appuntamento oggi" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <List
          loading={isLoading}
          dataSource={events}
          renderItem={(ev) => (
            <List.Item style={{ padding: '6px 0' }}>
              <div>
                <Text strong style={{ fontSize: 13 }}>{ev.titolo}</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 11 }}>
                  {new Date(ev.data_inizio).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}
                  {' – '}
                  {new Date(ev.data_fine).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}
                </Text>
              </div>
            </List.Item>
          )}
        />
      )}
    </Card>
  )
}
